var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ybl-select-tree",
    _vm._b(
      {
        ref: "stree",
        attrs: {
          showCheckbox: _vm.showCheckbox,
          items: _vm.originOrganization,
          props: _vm.treeDefaultProps,
          configValue: _vm.configValue,
          checkedChild: _vm.checkedChild,
          placeholder: _vm.$attrs.placeholder || "请选择组织机构",
          clearable: !_vm.$attrs.unclearable && !_vm.$attrs.disabled,
          filterDelete: _vm.filterDelete,
          readonly: _vm.$attrs.disabled,
          disableList: _vm.disableList
        },
        on: { clear: _vm.treeClear, change: _vm.selectedChange },
        model: {
          value: _vm.form.cusOrgId,
          callback: function($$v) {
            _vm.$set(_vm.form, "cusOrgId", $$v)
          },
          expression: "form.cusOrgId"
        }
      },
      "ybl-select-tree",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2aa6a03a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa6a03a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organization.vue
// module id = null
// module chunks = 